<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta de cierre de pagos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="cerrar" class="btn-primary btn--bigger">
            <i class="fa fa-times"></i>
            <span>Cerrar</span>
          </button>
          <button @click="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="form-field select2">
              <div class="select2-field select2-field--stretch">
                <v-select
                  placeholder="Seleccione..."
                  @input="inputDoctor"
                  id="doctor"
                  v-model="selectedDoctor"
                  :options="doctores"
                  label="nombre_cabecera"
                ></v-select>
                <label for="doctor">Médico</label>
                <span v-if="errores.doctor_id" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.doctor_id[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-9">
            <div class="form-inline">
              <label for="hoy">
                <input
                  @change="consultar"
                  v-model="form.tipo_fecha"
                  value="H"
                  type="radio"
                  name="tipo_fecha"
                  id="hoy"
                />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input
                  @change="consultar"
                  v-model="form.tipo_fecha"
                  value="A"
                  type="radio"
                  name="tipo_fecha"
                  id="ayer"
                />
                <span>Ayer</span>
              </label>
              <label for="personalizado">
                <input
                  @change="changePersonalizado"
                  v-model="form.tipo_fecha"
                  value="P"
                  type="radio"
                  name="tipo_fecha"
                  id="personalizado"
                />
                <span>Personalizado</span>
              </label>
              <div v-show="form.tipo_fecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    label="YYYY-MM-DD"
                    v-model="form.desde"
                    locale="es"
                    no-label
                    only-date
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                  />
                  <label for="desde">Desde</label>
                  <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-show="form.tipo_fecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="hasta"
                    v-model="form.hasta"
                    locale="es"
                    no-label
                    only-date
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    label="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                  />
                  <label for="hasta">Hasta</label>
                  <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.hasta[0] }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <k-table
          @errores="onErrores"
          @verDoctores="verDoctores"
          @editarCierre="editarCierre"
          @desconciliar="desconciliar"
          :buscarButton="false"
          :filterStatus="false"
          :params="form"
          ref="cierres"
          :path="path"
          :createButton="false"
          :editButton="false"
          :deleteButton="false"
          :buttons="[
                    {
                        icon : 'fa-user-md',
                        event : 'verDoctores',
                        class : 'btn-info',
                        tooltip: 'Ver médicos'
                    },
                    {
                        icon : 'fa-edit',
                        event : 'editarCierre',
                        class : 'btn-primary',
                        tooltip : 'Editar'
                    },
                    {
                        icon : 'fa-ban',
                        event : 'desconciliar',
                        class : 'btn-danger',
                        tooltip : 'Anular cierre'
                    }
                ]"
          :columns="[
                    {
                        display: 'Fecha de inicio',
                        value: 'fecha_inicio'
                    },
                    {
                        display: 'Fecha de corte',
                        value: 'fecha_corte'
                    },
                    {
                        display: 'Total en consultas',
                        value: 'total_consultas'
                    },
                    {
                        display: 'Total cancelado',
                        value: 'total_cancelado'
                    },
                    {
                        display: 'Consultas',
                        value: 'consultas_totales'
                    },
                    {
                        display: 'Observación',
                        value: 'observacion'
                    }
                ]"
        ></k-table>
      </div>
    </div>
    <modal name="doctores" scrollable width="50%" height="auto" adaptive reset resizable>
      <doctores-cierre-pago @cerrar="cerrarDoctores" :id="currentId"></doctores-cierre-pago>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    doctores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      form: {
        desde: "",
        hasta: "",
        tipo_fecha: "H",
        doctor_id: ""
      },
      selectedDoctor: null,
      errores: {
        desde: undefined,
        hasta: undefined
      },
      path: url + "/cierre-pago",
      currentId: ""
    };
  },
  methods: {
    cerrarDoctores: function() {
      this.$modal.hide("doctores");
    },
    editarCierre: function(consulta) {
      location.href = url + "/cierre-pago/" + consulta.id + "/edit";
    },
    desconciliar: function(consulta) {
      let that = this;
      swal({
        title: "¿Está seguro desea anular el cierre seleccionado?",
        text: "Se requiere de confirmación del usuario",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          axios
            .post(url + "/cierre-pago/" + consulta.id, {
              _method: "DELETE"
            })
            .then(function() {
              swal(
                "Se ha anulado el cierre corréctamente.",
                "Realizado",
                "success"
              );
              that.consultar();
            })
            .catch(function() {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    verDoctores: function(consulta) {
      this.currentId = consulta.id;
      this.$modal.show("doctores");
    },
    onErrores: function(errores) {
      this.errores = errores;
    },
    changePersonalizado: function() {
      this.form.hasta = moment(new Date()).format("YYYY-MM-DD");
      let desde = new Date();
      desde.setDate(desde.getDate() - 30);
      this.form.desde = moment(desde).format("YYYY-MM-DD");
    },
    cerrar: function() {
      location.href = url + "/cierre-pago/create";
    },
    inputDoctor: function() {
      if (this.selectedDoctor !== null)
        this.form.doctor_id = this.selectedDoctor.id;
      else this.form.doctor_id = "";
    },
    consultar: function() {
      this.errores = {};
      this.$refs.cierres.loadRows();
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/ConsultaCierrePagos.vue